<p>self-assessment-routing-component works!</p>
